(() => {
  class OrderFields extends HTMLElement {
    connectedCallback() {
      this.colorFields = Array.from(this.querySelectorAll('[data-order-color-field]'));
      if (!this.colorFields.length) return;

      this.colorFields.forEach((field) => {
        this.syncColorField(field);
        field.addEventListener('change', (event) => {
          if (event.target.matches('.product-form__order-swatch-input')) {
            this.syncColorField(field);
          }
        });
      });

      const form = this.closest('form');
      if (form) {
        form.addEventListener('submit', this.onSubmit.bind(this), true);
      }
    }

    onSubmit(event) {
      const invalidField = this.colorFields.find((field) => !this.validateColorField(field));
      if (!invalidField) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      invalidField.scrollIntoView({ block: 'center', behavior: 'smooth' });

      const firstInput = invalidField.querySelector('.product-form__order-swatch-input:not(:disabled)');
      if (firstInput) firstInput.focus({ preventScroll: true });
    }

    syncColorField(field) {
      const max = Number(field.dataset.maxOptions || 3);
      const inputs = Array.from(field.querySelectorAll('.product-form__order-swatch-input'));
      const selected = inputs.filter((input) => input.checked);
      const hiddenInput = field.querySelector('[data-order-color-value]');
      const message = field.querySelector('[data-order-color-message]');

      if (hiddenInput) {
        hiddenInput.value = selected.map((input) => input.value).join(', ');
        hiddenInput.disabled = selected.length === 0;
      }

      inputs.forEach((input) => {
        input.disabled = selected.length >= max && !input.checked;
      });

      field.classList.toggle('is-maxed', selected.length >= max);
      field.classList.remove('has-error');
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }
    }

    validateColorField(field) {
      const isRequired = field.dataset.required === 'true';
      const inputs = Array.from(field.querySelectorAll('.product-form__order-swatch-input'));
      const selected = inputs.filter((input) => input.checked);
      const message = field.querySelector('[data-order-color-message]');

      if (!isRequired || selected.length > 0) {
        field.classList.remove('has-error');
        if (message) {
          message.hidden = true;
          message.textContent = '';
        }
        return true;
      }

      field.classList.add('has-error');
      if (message) {
        message.textContent = 'בחרו לפחות צבע אחד';
        message.hidden = false;
      }
      return false;
    }
  }

  if (!customElements.get('order-fields')) {
    customElements.define('order-fields', OrderFields);
  }

  class WhatsappQuoteForm {
    constructor(form) {
      this.form = form;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();

      if (!this.form.reportValidity()) return;

      const phone = this.form.dataset.whatsappPhone || '';
      const baseMessage = this.form.dataset.whatsappMessage || 'היי, אשמח לקבל הצעת מחיר';
      const productUrl = this.getProductUrl();
      const properties = this.getProperties();
      const messageParts = [baseMessage, `קישור למוצר: ${productUrl}`];

      if (properties.length) {
        messageParts.push('', 'פרטים:');
        properties.forEach(({ label, value }) => {
          messageParts.push(`${label}: ${value}`);
        });
      }

      const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(messageParts.join('\n'))}`;
      window.open(whatsappUrl, '_blank', 'noopener');
    }

    getProductUrl() {
      const productUrl = this.form.dataset.whatsappProductUrl || window.location.href;
      const variantId = this.form.querySelector('input[name="id"]')?.value;

      if (!variantId) return productUrl;

      try {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        return url.toString();
      } catch (error) {
        return window.location.href;
      }
    }

    getProperties() {
      const fields = Array.from(this.form.querySelectorAll('[name^="properties["]'));

      return fields
        .map((field) => {
          const match = field.name.match(/^properties\[(.*)\]$/);
          const label = match ? match[1] : field.name;
          const value = field.value.trim();
          return { label, value };
        })
        .filter(({ value }) => value.length > 0);
    }
  }

  document.querySelectorAll('[data-whatsapp-quote-form]').forEach((form) => {
    if (form.dataset.whatsappQuoteReady === 'true') return;
    form.dataset.whatsappQuoteReady = 'true';
    new WhatsappQuoteForm(form);
  });
})();
